import React from 'react'
import Manager from '../../../public/components/Manager'
import EvaluationApplicationDiv from './EvaluationApplicationDiv'
import AddEvaluationApplicationDiv from './AddEvaluationApplicationDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        {
            icon: 'plus', text: '添加...', handler: ({ showDetail, refreshPage }) =>
            Tyan.pubForm.showDialog('评价项目', props => <AddEvaluationApplicationDiv {...props} id={0} onSave={refreshPage} showDetail={showDetail} />)
        },
    ],
    columns: [
        { _text: '评价编号', field: 'Number', search: true, flex: 1, locked: false },
        { _text: '评价项目名称', field: 'EvaluateItemName', search: true, flex: 1, },
        { _text: '申请原因', field: 'Reason', search: true, flex: 1, },
    ],
    onDoubleTap: ({ showDetail }, data) => showDetail(props => <EvaluationApplicationDiv {...props} id={data.id} />),
}

export default props => <Manager {...props} config={config} />